/**
 * Breakpoint configuration
 */
export default {
  small: 639, // 0-639
  medium: 959, // 640-959 // if ("index-legacy-navs.html") medium: 1023, // 640-1023
  large: 1279 // 960-1279 // if ("index-legacy-navs.html") large: 1279 // 1024-1279
};



/** WEBPACK FOOTER **
 ** ./src/css/breakpoints.js
 **/